<template>
  <VaNavbar class="app-layout-navbar py-1 md:py-2 px-2 md:px-4">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="20px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page" class="app-brand">
          <span class="brand-badge">
            <img src="/nyozan-logo.png" alt="Nyɔ̌zan" class="brand-logo" />
          </span>
        </RouterLink>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  /* background: linear-gradient(90deg, #6285fa 40%, #6285fa 55%, #6285fa 60%); */
  border-bottom: 1px solid #e4e2fb;
  box-shadow: 0 2px 10px rgba(79, 70, 229, 0.06);

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex !important;
  align-items: center !important;
  margin-left: 0 !important;
  gap: 0.5rem;

  @media screen and (max-width: 768px) {
    margin-left: 0 !important;
    gap: 0.25rem;
  }

  & > * {
    margin-right: 0;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
}

.app-brand {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 0.6rem !important;
  text-decoration: none !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  padding: 0.4rem 0.7rem !important;
  border-radius: 0.65rem !important;
  margin: 0 !important;
  color: var(--va-text-primary) !important;

  @media screen and (max-width: 768px) {
    gap: 0.45rem !important;
    padding: 0.25rem 0.5rem !important;
  }

  &:hover {
    background-color: rgba(124, 58, 237, 0.08) !important;
  }

  &:active {
    transform: translateY(0) !important;
  }
}

.brand-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  height: 34px;
}

.brand-logo {
  height: 100%;
  width: auto;

  object-fit: contain;
}

.app-brand .brand-title {
  display: inline-block !important;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif !important;
  font-size: 1.1rem !important;
  font-weight: 800 !important;
  color: var(--va-primary) !important;
  white-space: nowrap !important;
  letter-spacing: 0.3px !important;
  line-height: 1 !important;
  text-transform: uppercase !important;
  text-decoration: none !important;
  margin: 0 !important;
  padding: 0 !important;

  @media screen and (max-width: 768px) {
    font-size: 0.95rem !important;
  }
}

.brand-icon {
  color: var(--va-primary) !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}
</style>
